export default {
    path: "template",
    name: "template",
    component: () =>
        import ("@/layout/body.vue"),
    meta: [{
            title: "格式模板",
            path: "/index/template/formatTemplate",
            icon: "el-icon-s-unfold",
            name: "formatTemplate",
        },
        {
            title: "策略模板",
            path: "/index/template/strategyTemplate",
            icon: "el-icon-box",
            name: "strategyTemplate",
        },
        // {
        //     title: "任务模板",
        //     path: "/index/template/taskTemplate",
        //     icon: "el-icon-tickets",
        //     name: "taskTemplate",
        // },
    ],
    children: [{
            path: "formatTemplate",
            name: "formatTemplate",
            component: () =>
                import ("@/views/template/formatTemplate.vue"),
            meta: {
                title: "格式模板",
                parent: "模板管理",
            },
        },
        {
            path: "taskTemplate",
            name: "taskTemplate",
            component: () =>
                import ("@/views/template/taskTemplate.vue"),
            meta: {
                title: "任务模板",
                parent: "模板管理",
            },
        },
        {
            path: "formatTemplateChange/:type",
            name: "formatTemplateChange",
            component: () =>
                import ("@/views/template/formatTemplateChange.vue"),
            meta: {
                title: "添加格式模板",
                parent: "格式模板",
                isFocus: "formatTemplate"
            },
        },
        {
            path: "formatTemplateChange/:type/:id/:templatetype",
            name: "formatTemplateChange",
            component: () =>
                import ("@/views/template/formatTemplateChange.vue"),
            meta: {
                title: "修改格式模板",
                parent: "格式模板",
                isFocus: "formatTemplate"
            },
        },
        {
            path: "taskTemplateChange/:type",
            name: "taskTemplateChange",
            component: () =>
                import ("@/views/template/taskTemplateChange.vue"),
            meta: {
                title: "添加任务模板",
                parent: "任务模板",
                isFocus: "taskTemplate"
            },
        },
        {
            path: "strategyTemplate",
            name: "strategyTemplate",
            component: () =>
                import ("@/views/template/strategyTemplate.vue"),
            meta: {
                title: "策略模板",
                parent: "模板管理",
            },
        },
        {
            path: "strategyTemplateChange/:type",
            name: "strategyTemplateChangeAdd",
            component: () =>
                import ("@/views/template/strategyTemplateChange.vue"),
            meta: {
                title: "添加策略模板",
                parent: "策略模板",
                isFocus: "strategyTemplate"
            },
        },
        {
            path: "strategyTemplateChange/:type/:id",
            name: "strategyTemplateChangeEdit",
            component: () =>
                import ("@/views/template/strategyTemplateChange.vue"),
            meta: {
                title: "编辑策略模板",
                parent: "策略模板",
                isFocus: "strategyTemplate"
            },
        },
    ],
};